import clsx from 'clsx'

import { FvDate, Icon } from '@fv/client-components'

import CheckboxField from '@/components/inputs/CheckboxField'
import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useUpdateNotificationStatus } from './mutations'
import {
  getNotificationTitle,
  notificationRegistry,
} from './NotificationRegistry'
import type { Notification } from './queries'

const DEFAULT_ICON_COLOR = 'text-fv-gray-dark'
const DEFAULT_BG_COLOR = 'bg-fv-beer-xlight'

type Props = {
  notification: Notification
  checked?: boolean
  onCheckboxChange: (checked: boolean) => void
  onSelect: () => void
  isActive: boolean
}
export const NotificationItem = ({
  notification,
  checked,
  onCheckboxChange,
  onSelect,
  isActive,
}: Props) => {
  const markAsRead = useUpdateNotificationStatus(notification)
  const { icon, iconColor, bgColor } =
    notificationRegistry[notification.notificationType]
  const isUnread = !notification.readDate

  const handleClick = () => {
    isUnread && markAsRead.mutate({ read: true })
    onSelect()
  }
  return (
    <div
      key={notification._id}
      className="flex items-center gap-x-4 flex-1 relative"
    >
      <CheckboxField
        checked={checked}
        name={`checkbox-${notification._id}`}
        onChange={e => onCheckboxChange(e.target.checked)}
      />
      <button
        onClick={handleClick}
        className={clsx(
          'relative bg-white z-20 text-left flex flex-1 ',
          isActive
            ? 'border-2 border-fv-orange -mr-6 pr-6 border-r-0 -mx-px opacity-100'
            : 'border border-fv-gray my-px opacity-90',
        )}
      >
        <div
          className={clsx(
            'border-r flex flex-col justify-center items-center border-fv-gray relative px-4 gap-y-2 ',
            bgColor ?? DEFAULT_BG_COLOR,
          )}
        >
          {isUnread && (
            <ShipperTooltip label="Unread">
              <div className="w-3 h-3 bg-fv-blue absolute -top-[.1rem] -left-1 rounded-full z-30" />
            </ShipperTooltip>
          )}
          {notification.pinned && (
            <Icon icon="thumbtack" className="text-fv-gray-dark" />
          )}
          <Icon icon={icon} className={clsx(iconColor ?? DEFAULT_ICON_COLOR)} />
        </div>
        <div className={clsx('p-4 overflow-hidden flex-1')}>
          <div className="text-black flex justify-between">
            <div>{getNotificationTitle(notification)}</div>
            <div
              className={clsx(
                'absolute -right-[1px] -top-[1px] text-xs italic border-fv-gray border px-1 leading-none flex items-center bg-fv-beer-xlight self-start py-1',
                isActive && 'right-6',
              )}
            >
              <FvDate val={notification.created} format="M/D/YY h:mm a" utc />
            </div>
          </div>
          <p className="mb-0 line-clamp-3 text-sm">
            {/* hiding export text */}
            {notification.notificationType !== 'export' && notification.text}
          </p>
        </div>
      </button>
    </div>
  )
}
